var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPython2 = function SvgPython2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#779AF1",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.575 9.512c-.343-1.372-.998-2.4-2.37-2.4H15.43v2.12c0 1.651-1.402 3.023-2.961 3.023H7.699c-1.309 0-2.369 1.122-2.369 2.431v4.52c0 1.278 1.122 2.057 2.37 2.43 1.495.437 2.96.53 4.768 0 1.184-.342 2.369-1.059 2.369-2.43v-1.808h-4.769v-.592h7.138c1.371 0 1.901-.967 2.369-2.4.498-1.559.498-2.993 0-4.894Zm-6.826 9.04a.905.905 0 0 1 0 1.807c-.5.031-.904-.405-.904-.904s.405-.904.903-.904Zm-5.268-6.92h4.769c1.309 0 2.369-1.091 2.369-2.432V4.68c0-1.277-1.091-2.244-2.37-2.462-1.589-.25-3.334-.25-4.768 0-2.026.343-2.369 1.091-2.369 2.463v1.807h4.769v.593H3.335c-1.371 0-2.587.841-2.96 2.4-.437 1.808-.468 2.93 0 4.831.342 1.403 1.153 2.4 2.524 2.4h1.62V14.53c-.03-1.527 1.341-2.898 2.962-2.898Zm-.312-6.36a.905.905 0 1 1 .001-1.808.905.905 0 0 1 0 1.809Z",
    fill: "#A9673F"
  })));
};
export default SvgPython2;